<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-30 09:57:37
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-02-18 17:14:18
-->
<script lang='ts' setup>
import type { LocationShowCodeEnum, TemplateTypeCode, TopicTemplateNewsItem, TopicTemplatePage, TopicTemplatePageParams } from '~/server/types'
import { topicTemplatePageDataApi } from '@/server'

import { LOAD_STATE } from '@/shared/types'
import { locationShowCodeEnum } from '~/server/types'

import { usePagination } from '@/composables/usePagination'

const props = withDefaults(defineProps<{
  locationShowCode: keyof LocationShowCodeEnum<3>
  templateTypeCode: TemplateTypeCode
  topicId: string
}>(), {})

const data = ref<TopicTemplateNewsItem []>([])

const pagination = usePagination({
  key: `topicTemplatePageDataApi-${props.topicId}`,
  request: params =>
    topicTemplatePageDataApi<3, 1301>({
      templateTypeCode: props.templateTypeCode,
      locationShowCodeEnum: locationShowCodeEnum[3][props.locationShowCode],
      topicId: props.topicId,
      ...params,
    }),

})
async function getNewsPage() {
  const { list } = await pagination.loadPaginationData() || {}

  if (!list)
    return
  data.value.push(...format(list))
}

const state = computed(() => pagination.pagination.status)

function format(list: TopicTemplateNewsItem[]) {
  return list.map(i => ({ ...i, articleFormatCode: 0 }))
}

async function init(locationShowCode: keyof LocationShowCodeEnum<3>) {
  pagination.setPage()
  pagination.setParams({ locationShowCodeEnum: locationShowCodeEnum[3][locationShowCode] })

  await getNewsPage()
}

watch(() => props.locationShowCode, async (locationShowCode) => {
  if (locationShowCode)

    await init(locationShowCode)
}, { immediate: true })
</script>

<template>
  <div>
    <UtilLoadState :reload-handler="getNewsPage" type="up" :length="data.length" :state="state">
      <Article-item v-for="i in data" :key="i.id" my-3 :item="i" />
    </UtilLoadState>
    <BasicLoadButton class="bg-slate-2" :state="state" @load="() => getNewsPage()" />
  </div>
</template>

<style lang='scss' scoped></style>
